import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import { connect } from 'react-redux';

import { fullAutoOptions } from 'constants/asyncClient';
import { openModalProject } from 'actions/modalActions';
import { getProject, getProjectMass, getUser } from 'actions/asyncActions';

import SidebarContainer from '../SidebarContainer';
import ProjectCard from 'components/cards/project/ProjectCard';
import { getProjectName } from 'helpers/fieldsHelpers';

class ProjectSidebar extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        getProject: PropTypes.object.isRequired,
        openModalProject: PropTypes.func
    };

    render() {
        const { params, getProject: { data : project, meta, refresh }, openModalProject } = this.props;
        const title = meta.success ? getProjectName(project) : params.title;
        const modal = {
            openModal: () => openModalProject({ id: project.id, text: title }),
            type: 'project',
        };

        return (
            <SidebarContainer meta={meta} title={title} refresh={refresh} headerModal={modal}>
                <ProjectCard project={project} meta={meta} />
            </SidebarContainer>
        );
    }
}

export const ProjectSidebarView = connect(null, { openModalProject })(
    withAsyncActions({
        getProject: getProject.withPayload(({ id }) => id)
    }, fullAutoOptions)(ProjectSidebar)
);

const stateToProps = state => ({
    userId: getUser.selectData(state).id
});

export const ProjectMassSidebarView = connect(stateToProps, { openModalProject })(
    withAsyncActions({
        getProject: getProjectMass.withPayload(({ id, userId }) => ({ userId, prjId: id }))
    }, fullAutoOptions)(ProjectSidebar)
);
